import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React from "react";

const inspectionLevels = ["Level 1", "Level 2", "Level 3", "Level 4"];

const fields = [
  { name: "jobNumber", label: "Job Number", type: "text" },
  { name: "documentNumber", label: "Document Number", type: "text" },
  {
    name: "clientProjectNameNo",
    label: "Clint/Project Name/No.",
    type: "text",
  },
  {
    name: "manufacturingLocation",
    label: "Manufacturing Location",
    type: "text",
  },
  { name: "endUser", label: "End User", type: "text" },
  { name: "clientPONumber", label: "Client PO Number", type: "text" },
  { name: "tagNumber", label: "Tag Number", type: "text" },
  { name: "equipmentName", label: "Equipment Name", type: "text" },
  { name: "projectManager", label: "Project Manager", type: "text" },
  { name: "projectEngineer", label: "Project Engineer", type: "text" },
  {
    name: "scopeOfWorkDescription",
    label: "Scope of work Description",
    type: "text",
    multiline: true,
    rows: 3,
    xs: 12,
  },
];

const buildInitialValues = (generalData) =>
  fields.reduce((acc, f) => {
    acc[f.name] = generalData?.[f.name] ?? "";
    return acc;
  }, {});

export default function GeneralTab({ generalData }) {
  const [form, setForm] = React.useState(() => buildInitialValues(generalData));
  const [inspectionLevel, setInspectionLevel] = React.useState(
    generalData?.inspectionLevel ?? inspectionLevels[0],
  );

  React.useEffect(() => {
    setForm(buildInitialValues(generalData));
    if (generalData?.inspectionLevel)
      setInspectionLevel(generalData.inspectionLevel);
  }, [generalData]);

  const handleFieldChange = (name) => (e) => {
    let v = e.target.value;
    setForm((prev) => ({ ...prev, [name]: v }));
  };

  const handleInspectionChange = (e) => {
    setInspectionLevel(e.target.value);
  };
  return (
    <>
      <Grid container spacing={1} sx={{ px: 1 }}>
        {fields.map((f) => (
          <Grid item xs={f.xs ?? 4} key={f.name}>
            {f.name === "scopeOfWorkDescription" ? (
              <Grid container alignItems="flex-start" spacing={1}>
                <Grid item>
                  <span style={{ fontWeight: 500 }}>{f.label} :</span>
                </Grid>

                <Grid item>
                  <TextField
                    value={form[f.name] ?? ""}
                    onChange={handleFieldChange(f.name)}
                    type={f.type ?? "text"}
                    size="small"
                    variant="outlined"
                    multiline={!!f.multiline}
                    rows={f.rows}
                    sx={{ width: 290 }}
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs={4} sx={{ fontWeight: 500 }}>
                  {f.label} :
                </Grid>

                <Grid item xs={8}>
                  <TextField
                    value={form[f.name] ?? ""}
                    onChange={handleFieldChange(f.name)}
                    type={f.type ?? "text"}
                    size="small"
                    variant="outlined"
                    multiline={!!f.multiline}
                    rows={f.rows}
                    sx={{ width: 230 }}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2} sx={{ px: 2, pt: 1 }}>
        <Grid item xs={12}>
          Inspection Level :{"     "}
          <RadioGroup
            row
            value={inspectionLevel}
            onChange={handleInspectionChange}
            name="inspection-level"
            sx={{ display: "inline-flex" }}
          >
            {inspectionLevels.map((option) => (
              <FormControlLabel
                key={option}
                value={option}
                control={<Radio />}
                label={option}
                sx={{ mx: 1 }}
              />
            ))}
          </RadioGroup>
        </Grid>
      </Grid>
    </>
  );
}
